/**
 * cm-promo-loader.js
 * 
 * Hydrates <div id="cm-promo" data-lifestage="..."> elements in blog articles.
 * Fetches lifestage-specific promo JSON pool from GCS and renders a UGC product card.
 * Each article gets a different item from the pool based on its URL path hash.
 * 
 * JSON format: { items: [ { media, type, caption, product, url, prefix }, ... ] }
 * 
 * This file is hosted as a Shopify theme asset so the flash-sale timer
 * can be controlled from the live theme without relying on a stale GCS copy.
 */
(function() {
  var TEST_LOOP_MINUTES = 0;
  var TEST_LOOP_ANCHOR_LOCAL = '';

  function numberOr(value, fallback) {
    var n = Number(value);
    return isFinite(n) ? n : fallback;
  }

  function parseLocalIso(value) {
    var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2})(?::?(\d{2}))?(?::?(\d{2}))?)?/);
    if (!match) return { year: 2026, month: 5, day: 3, hour: 0, minute: 0, second: 0 };
    return {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
      hour: Number(match[4] || 0),
      minute: Number(match[5] || 0),
      second: Number(match[6] || 0)
    };
  }

  function zonedParts(date, timeZone) {
    var out = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date).forEach(function(part) {
      if (part.type !== 'literal') out[part.type] = part.value;
    });
    return {
      year: Number(out.year),
      month: Number(out.month),
      day: Number(out.day),
      hour: Number(out.hour),
      minute: Number(out.minute),
      second: Number(out.second)
    };
  }

  function msFromLocalParts(parts) {
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour || 0, parts.minute || 0, parts.second || 0);
  }

  function formatCountdown(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var days = Math.floor(total / 86400);
    total -= days * 86400;
    var hours = Math.floor(total / 3600);
    total -= hours * 3600;
    var mins = Math.floor(total / 60);
    var secs = total - mins * 60;
    var hh = String(hours).padStart(2, '0');
    var mm = String(mins).padStart(2, '0');
    var ss = String(secs).padStart(2, '0');
    if (days > 0) return days + 'd ' + hh + 'h ' + mm + 'm';
    return hh + ':' + mm + ':' + ss;
  }

  function patchFlashSale() {
    window.__emFlashSaleConfig = Object.assign({}, window.__emFlashSaleConfig || {}, {
      testLoopMinutes: TEST_LOOP_MINUTES,
      testLoopAnchorLocal: TEST_LOOP_ANCHOR_LOCAL
    });

    if (!window.__emFlashSale) return false;
    if (window.__emFlashSale.__cmPromoLoopPatched) return true;

    var originalGetConfig = typeof window.__emFlashSale.getConfig === 'function'
      ? window.__emFlashSale.getConfig.bind(window.__emFlashSale)
      : function() { return window.__emFlashSaleConfig || {}; };
    var originalGetState = typeof window.__emFlashSale.getState === 'function'
      ? window.__emFlashSale.getState.bind(window.__emFlashSale)
      : null;

    window.__emFlashSale.getState = function(now) {
      var cfg = originalGetConfig() || window.__emFlashSaleConfig || {};
      var testLoopMinutes = Math.max(0, Math.floor(numberOr(cfg.testLoopMinutes, 0)));
      if (testLoopMinutes <= 0 && originalGetState) return originalGetState(now);

      var currentParts = zonedParts(now || new Date(), cfg.timezone || 'Australia/Melbourne');
      var currentLocalMs = msFromLocalParts(currentParts);
      var testAnchor = parseLocalIso(cfg.testLoopAnchorLocal || TEST_LOOP_ANCHOR_LOCAL || cfg.anchorLocal);
      var testAnchorLocalMs = msFromLocalParts(testAnchor);
      var testCycleMs = testLoopMinutes * 60000;
      var elapsedMs = currentLocalMs - testAnchorLocalMs;
      var offsetMs = ((elapsedMs % testCycleMs) + testCycleMs) % testCycleMs;
      var remainingMs = testCycleMs - offsetMs;

      if (!isFinite(remainingMs) || remainingMs <= 0 || remainingMs > testCycleMs) {
        remainingMs = testCycleMs;
      }

      return {
        active: true,
        override: 'test_loop',
        timezone: cfg.timezone || 'Australia/Melbourne',
        currentParts: currentParts,
        daysSinceAnchor: 0,
        dayInCycle: 0,
        onDays: Math.max(1, Math.floor(numberOr(cfg.onDays, 3))),
        offDays: Math.max(0, Math.floor(numberOr(cfg.offDays, 3))),
        cycleLen: 1,
        endLocalMs: currentLocalMs + remainingMs,
        nextStartLocalMs: currentLocalMs + remainingMs,
        remainingMs: remainingMs,
        testLoopMinutes: testLoopMinutes
      };
    };

    if (typeof window.__emFlashSale.formatCountdown !== 'function') {
      window.__emFlashSale.formatCountdown = formatCountdown;
    }

    window.__emFlashSale.__cmPromoLoopPatched = true;
    window.dispatchEvent(new Event('em-flash-sale-patched'));
    return true;
  }

  if (!patchFlashSale()) {
    var tries = 0;
    var timer = window.setInterval(function() {
      tries += 1;
      if (patchFlashSale() || tries > 100) window.clearInterval(timer);
    }, 100);
  }
})();

(function() {
  var d = document.getElementById('cm-promo');
  if (!d) return;

  var s = d.dataset.lifestage || 'general';

  function detectLocale() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var path = window.location.pathname || '';
    if (lang.indexOf('de') === 0) return 'de';
    if (path === '/de' || path.indexOf('/de/') === 0) return 'de';
    return 'en';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function fetchJsonWithFallback(urls) {
    if (!urls.length) return Promise.reject(new Error('No promo URLs'));

    var url = urls[0];
    return fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .catch(function(err) {
        if (urls.length === 1) throw err;
        return fetchJsonWithFallback(urls.slice(1));
      });
  }

  var locale = detectLocale();
  var urls = locale === 'de'
    ? [
        'https://storage.googleapis.com/convomesh-dev-seo-pages/promos/' + s + '.de.json',
        'https://storage.googleapis.com/convomesh-dev-seo-pages/promos/' + s + '.json'
      ]
    : ['https://storage.googleapis.com/convomesh-dev-seo-pages/promos/' + s + '.json'];
  var ctaLabel = locale === 'de' ? 'Zum Look' : 'Shop the look';

  function hashPath(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    }
    return h < 0 ? -h : h;
  }

  fetchJsonWithFallback(urls)
    .then(function(data) {
      var items = data.items || [data];
      if (!items.length) {
        d.remove();
        return;
      }

      var idx = hashPath(window.location.pathname) % items.length;
      var p = items[idx];

      var media = p.type === 'VIDEO'
        ? '<video src="' + p.media + '" autoplay muted loop playsinline style="width:100%;display:block;border-radius:12px 12px 0 0"></video>'
        : '<img src="' + p.media + '" style="width:100%;display:block;border-radius:12px 12px 0 0" alt="" loading="lazy">';

      var caption = p.caption || '';
      var shortCap = caption.length > 120 ? caption.substring(0, 120) + '...' : caption;

      d.innerHTML =
        '<a href="' + escapeHtml(p.url) + '" target="_blank" rel="noopener" style="display:block;text-decoration:none;border-radius:12px;overflow:hidden;border:1px solid #e5e0d8">' +
          '<div style="position:relative;background:#f5f0e6">' + media + '</div>' +
          '<div style="padding:14px 16px;background:#faf8f5;border-top:none">' +
            '<p style="margin:0 0 8px;font-size:14px;line-height:1.5;color:#3d2b1f">' + escapeHtml(shortCap) + '</p>' +
            '<p style="margin:0;font-size:15px;font-weight:600;color:#3d2b1f">' + escapeHtml(p.product) + '</p>' +
            '<p style="margin:4px 0 0;font-size:13px;color:#8B6B7B">' + escapeHtml(ctaLabel) + ' &rarr;</p>' +
          '</div>' +
        '</a>';
    })
    .catch(function() {
      d.remove();
    });
})();
